<template>
  <Component
    v-if="url && file && componentIs"
    v-bind="componentProps"
    :is="componentIs"
    class="h-full w-full"
  />
</template>

<script setup>
import {computed, defineAsyncComponent} from "vue";

const props = defineProps({
  file: {
    type: Object,
    required: false,
  },
  url: {
    type: String,
    required: true,
  },
});

const docxPreview = defineAsyncComponent({
  loader: () => import("./PreviewDocx.vue"),
});

const txtPreview = defineAsyncComponent({
  loader: () => import("./PreviewTxt.vue"),
});

const notSupportedPreview = defineAsyncComponent({
  loader: () => import("./NotSupportedPreview.vue"),
});

const finalMimeType = computed(() => {
  if (props.file) return props.file.type;
  return props.mimeType;
});

const componentIs = computed(() => {
  switch (finalMimeType.value) {
  case "application/pdf":
    return "iframe";
  case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    return docxPreview;
  case "text/plain":
    return txtPreview;
  default:
    return notSupportedPreview;
  }
});

const componentProps = computed(() => {
  switch (finalMimeType.value) {
  case "application/pdf":
    return {
      src: props.url + "#toolbar=0&navpanes=0",
      type: "application/pdf",
      title: "Document Preview",
      style: "bg-slate-500",
    };
  case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
  case "text/plain":
    return {
      src: props.file,
    };
  default:
    return {};
  }
});
</script>
